// Auto-generated file - do not edit manually
// This file is generated by scripts/generate-version.js
export const VERSION = "0.1.56";
